//Refrence:  https://www.i18next.com/

import i18next from "i18next";
import moment from "moment";
import Validation from "../constants/validation";

var language =
    i18next.language || window.navigator.userLanguage || window.navigator.language || "en-IN";
var languageJson = null;

const dateTimeFormatter = (value, formatType, lng, noUTC) => {
    if (noUTC) {
        return moment(value)
            .locale(lng)
            .format(formatType);
    }
    return moment
        .utc(value)
        .local()
        .locale(lng)
        .format(formatType);
};

const numberFormatter = (value, lng) => {
    return new Intl.NumberFormat(lng).format(value);
};

const currencyFormatter = (value, formatType, lng) => {
    // return new Intl.NumberFormat(lng, {style: 'currency', currency: formatType, maximumSignificantDigits: 3 }).format(value)
    return new Intl.NumberFormat(lng, { style: "currency", currency: formatType }).format(value);
};

const shortNumberFormatter = (value, formatType, lng) => {
    let shortCurr = new Intl.NumberFormat(lng, {
        style: "currency",
        currency: formatType,
        notation: "compact",
        compactDisplay: "short"
    }).format(value);
    return shortCurr.slice(1);
};

let options = {
    interpolation: {
        escapeValue: false, // not needed for react!!,
        format: (value, typeAndFormat, lng) => {
            const [type, format, noUTC] = typeAndFormat.split("---");
            switch (type) {
                case "date":
                    return dateTimeFormatter(value, format, lng, noUTC);
                case "dateTime":
                    return dateTimeFormatter(value, format, lng, noUTC);
                case "dateTime1":
                    return dateTimeFormatter(value, format, lng, noUTC);
                case "time":
                    return dateTimeFormatter(value, format, lng, noUTC);
                case "month":
                    return dateTimeFormatter(value, format, lng, noUTC);
                case "number":
                    return numberFormatter(value, lng);
                case "currency":
                    return currencyFormatter(value, format, lng);
                case "shortNumber":
                    return shortNumberFormatter(value, format, lng);
                default:
                    return value;
            }
        }
    },
    initImmediate: false,

    // if want to show missing key warning in console then make it true.
    debug: false,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    load: "languageOnly",

    react: {
        // wait: false,
        bindI18n: "languageChanged loaded",
        bindStore: "added removed",
        nsMode: "default",
        defaultTransParent: "div"
    }
};

const custom = {
    type: "logger",

    log: function(args) {
        console.log("Logs:: 😞 ", args);
    },
    warn: function(args) {
        console.warn("Warn:: 😥:: ", args);
    },
    error: function(args) {
        console.error("Err:: 💩:: ", args);
    }
};

function init(lng) {
    let env = "prd";

    if (
        window.location &&
        (window.location.hostname.includes("prep") || window.location.hostname.includes("uat"))
    ) {
        env = "uat";
    }

    options["lng"] = lng;
    options["fallbackLng"] = lng;

    languageJson = require(`../locales/en-IN.json`);
    languageJson = languageJson["en-IN"];

    let resources = {
        [language]: {
            translations: languageJson
        }
    };
    options["resources"] = resources;

    i18next.use(custom).init(options);

    // Uncomment below code if need localization strings from backend
    // Putting a org ID check
    if (!lng.includes("en") && localStorage.getItem("happay.org_id") === "HPORG2022729426193756572186HP") {
        fetch(
            `https://glr-api.${env}.happay.in/locale/v1.0/get-translated-string/?application=frontend&locale_code=${lng}`
        )
            .then(res => res.json())
            .then(res => {
                let resources = {
                    [lng]: {
                        translations: res
                    }
                };
                options["resources"] = resources;

                i18next.use(custom).init(options);
            }).catch(err => {
                let resources = {
                    ["en-IN"]: {
                        translations: languageJson
                    }
                };
                options["resources"] = resources;

                i18next.use(custom).init(options);
            })
    }
}

i18next.on("languageChanged", function(lng) {
    let formatLng = Validation._getLanguageFormat(lng);
    if (language !== formatLng) {
        language = formatLng;

        // moment.locale(formatLng)
        init(formatLng);
    }
});

init(language);

export default i18next;
